module.exports = __webpack_public_path__ + "static/media/mai3.1425bc6f.jpg";